import { render, staticRenderFns } from "./MarketWatch.vue?vue&type=template&id=617e9fa6&scoped=true&"
import script from "./MarketWatch.vue?vue&type=script&lang=js&"
export * from "./MarketWatch.vue?vue&type=script&lang=js&"
import style0 from "./MarketWatch.vue?vue&type=style&index=0&id=617e9fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e9fa6",
  null
  
)

export default component.exports